// Bottom sheet (modal) helpers, ported from the prototype's openSheet()/closeSheet().
let lastFocused: HTMLElement | null = null;

export function openSheet(html: string): void {
  const content = document.getElementById('sheetContent');
  const overlay = document.getElementById('overlay');
  const sheet = document.getElementById('sheet');
  if (!content || !overlay || !sheet) return;
  lastFocused = document.activeElement as HTMLElement | null;
  content.innerHTML = html;
  overlay.classList.add('show');
  sheet.classList.add('show');
  // a11y: move focus into the sheet so keyboard/screen-reader users land on it.
  const focusable = sheet.querySelector<HTMLElement>(
    'input, select, textarea, button, [href], [tabindex]:not([tabindex="-1"])'
  );
  focusable?.focus();
  document.addEventListener('keydown', onKeydown);
}

export function closeSheet(): void {
  const overlay = document.getElementById('overlay');
  const sheet = document.getElementById('sheet');
  overlay?.classList.remove('show');
  sheet?.classList.remove('show');
  document.removeEventListener('keydown', onKeydown);
  lastFocused?.focus();
}

function onKeydown(ev: KeyboardEvent): void {
  if (ev.key === 'Escape') closeSheet();
}

export function initSheetOverlay(): void {
  document.getElementById('overlay')?.addEventListener('click', closeSheet);
}
